import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { FinishMerchLater } from '@webapp/store/merch/action-creators';

import Button from '@components/actions/button';
import Typography from '@components/basics/typography';

import NavbarItemAvatarCtrl from '../navbar-items/navbar-item-avatar';
import { Translate } from 'react-localize-redux';

interface NavbarActionsMerchCtrlProps {
  className?: string;
  isMobile: true;
  hideButton?: boolean;
}

interface NavbarActionsMerchStateProps {
  disabledFinishLater: boolean;
  finishLater: () => FinishMerchLater;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  disabledFinishLater: !(
    state.merch.active?.editProduct?.id ||
    state.merch.active?.newProduct?.productId
  ),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  finishLater: () => dispatch(new FinishMerchLater()),
});

export const NavbarActionsMerchCtrl: React.FC<
  NavbarActionsMerchCtrlProps & NavbarActionsMerchStateProps
> = ({ className, disabledFinishLater, finishLater, hideButton }) => {
  const getStatusText = () => {
    return 'COMMON.FINISH_LATER';
  };

  const handleFinishLater = () => {
    finishLater();
  };

  return (
    <div className={className}>
      <div className="release-navbar">
        <NavbarItemAvatarCtrl className="navbar-artist" noHover noIcons />
        {hideButton ? null : (
          <Button
            buttonType="secondary"
            small
            disabled={disabledFinishLater}
            onClick={handleFinishLater}
          >
            <Typography className="item-title" weight="700">
              <Translate id={getStatusText()} />
            </Typography>
          </Button>
        )}
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(NavbarActionsMerchCtrl)`
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    width: auto;
  }

  .navbar-artist,
  .delete-button {
    margin-right: 30px;
  }

  .release-navbar {
    display: flex;
    align-items: center;

    .status {
      margin: 0 35px 0 9px;
    }
  }
`);
